import { useMatch, useResolvedPath } from 'react-router-dom'

export default function useIsCurrentLink(pathname: string | undefined) {
	const resolved = useResolvedPath(pathname || '')

	const match = useMatch({ path: resolved.pathname, end: true })

	return match
}
